<template>
  <div
    class="watermark-mode"
    @click="$emit('click-icon')"
  >
    <!-- diagonal -->
    <svg v-if="typeIcon == 'diagonal'" width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_968_35815)">
      <path d="M59.5 35.5C59.5 34.1739 60.0268 32.9021 60.9645 31.9645C61.9021 31.0268 63.1739 30.5 64.5 30.5H79.5C80.8261 30.5 82.0978 31.0268 83.0355 31.9645C83.9732 32.9021 84.5 34.1739 84.5 35.5V50.5C84.5 51.8261 83.9732 53.0978 83.0355 54.0355C82.0978 54.9732 80.8261 55.5 79.5 55.5H64.5C63.1739 55.5 61.9021 54.9732 60.9645 54.0355C60.0268 53.0978 59.5 51.8261 59.5 50.5V35.5Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M67.625 41.75C69.3509 41.75 70.75 40.3509 70.75 38.625C70.75 36.8991 69.3509 35.5 67.625 35.5C65.8991 35.5 64.5 36.8991 64.5 38.625C64.5 40.3509 65.8991 41.75 67.625 41.75Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M75.1575 43.7791L64.5 55.5028H79.6662C80.9482 55.5028 82.1777 54.9935 83.0842 54.087C83.9907 53.1805 84.5 51.9511 84.5 50.6691V50.5028C84.5 49.9203 84.2813 49.6966 83.8875 49.2653L78.85 43.7716C78.6152 43.5155 78.3296 43.3111 78.0115 43.1715C77.6933 43.032 77.3495 42.9602 77.0021 42.9609C76.6547 42.9616 76.3112 43.0348 75.9936 43.1756C75.676 43.3165 75.3912 43.522 75.1575 43.7791V43.7791Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <line x1="-11.3536" y1="51.0683" x2="39.0702" y2="0.644594" stroke="black"/>
      <line x1="-5.58988" y1="85.6464" x2="79.4101" y2="0.646448" stroke="black"/>
      <line x1="29.748" y1="90.6464" x2="119.748" y2="0.646448" stroke="black"/>
      <line x1="66.0879" y1="94.6464" x2="160.088" y2="0.646444" stroke="black"/>
      <line x1="104.986" y1="94.6464" x2="198.986" y2="0.646444" stroke="black"/>
      </g>
      <rect v-if="active" x="1" y="1" width="138" height="88" stroke="#00ABEC" stroke-width="2"/>
      <rect v-else x="0.5" y="0.5" width="139" height="89" stroke="black"/>
      <defs>
      <clipPath id="clip0_968_35815">
      <rect width="140" height="90" fill="white"/>
      </clipPath>
      </defs>
    </svg>

    <!-- horizontal -->
    <svg v-if="typeIcon == 'horizontal'" width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="14.5" x2="140" y2="14.5" stroke="black"/>
      <line y1="34.5" x2="140" y2="34.5" stroke="black"/>
      <line y1="54.5" x2="140" y2="54.5" stroke="black"/>
      <line y1="74.5" x2="140" y2="74.5" stroke="black"/>
      <path d="M59.5 35.5C59.5 34.1739 60.0268 32.9021 60.9645 31.9645C61.9021 31.0268 63.1739 30.5 64.5 30.5H79.5C80.8261 30.5 82.0978 31.0268 83.0355 31.9645C83.9732 32.9021 84.5 34.1739 84.5 35.5V50.5C84.5 51.8261 83.9732 53.0978 83.0355 54.0355C82.0978 54.9732 80.8261 55.5 79.5 55.5H64.5C63.1739 55.5 61.9021 54.9732 60.9645 54.0355C60.0268 53.0978 59.5 51.8261 59.5 50.5V35.5Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M67.625 41.75C69.3509 41.75 70.75 40.3509 70.75 38.625C70.75 36.8991 69.3509 35.5 67.625 35.5C65.8991 35.5 64.5 36.8991 64.5 38.625C64.5 40.3509 65.8991 41.75 67.625 41.75Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M75.1575 43.7791L64.5 55.5028H79.6662C80.9482 55.5028 82.1777 54.9935 83.0842 54.087C83.9907 53.1805 84.5 51.9511 84.5 50.6691V50.5028C84.5 49.9203 84.2813 49.6966 83.8875 49.2653L78.85 43.7716C78.6152 43.5155 78.3296 43.3111 78.0115 43.1715C77.6933 43.032 77.3495 42.9602 77.0021 42.9609C76.6547 42.9616 76.3112 43.0348 75.9936 43.1756C75.676 43.3165 75.3912 43.522 75.1575 43.7791V43.7791Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <rect v-if="active" x="1" y="1" width="138" height="88" stroke="#00ABEC" stroke-width="2"/>
      <rect v-else x="0.5" y="0.5" width="139" height="89" stroke="black"/>
    </svg>

    <!-- vertical -->
    <svg v-if="typeIcon == 'vertical'" width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="20.5" y1="2.18557e-08" x2="20.5" y2="90" stroke="black"/>
      <line x1="40.5" y1="2.18557e-08" x2="40.5" y2="90" stroke="black"/>
      <line x1="60.5" y1="2.18557e-08" x2="60.5" y2="90" stroke="black"/>
      <line x1="80.5" y1="2.18557e-08" x2="80.5" y2="90" stroke="black"/>
      <line x1="100.5" y1="2.18557e-08" x2="100.5" y2="90" stroke="black"/>
      <line x1="120.5" y1="2.18557e-08" x2="120.5" y2="90" stroke="black"/>
      <path d="M59.5 35.5C59.5 34.1739 60.0268 32.9021 60.9645 31.9645C61.9021 31.0268 63.1739 30.5 64.5 30.5H79.5C80.8261 30.5 82.0978 31.0268 83.0355 31.9645C83.9732 32.9021 84.5 34.1739 84.5 35.5V50.5C84.5 51.8261 83.9732 53.0978 83.0355 54.0355C82.0978 54.9732 80.8261 55.5 79.5 55.5H64.5C63.1739 55.5 61.9021 54.9732 60.9645 54.0355C60.0268 53.0978 59.5 51.8261 59.5 50.5V35.5Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M67.625 41.75C69.3509 41.75 70.75 40.3509 70.75 38.625C70.75 36.8991 69.3509 35.5 67.625 35.5C65.8991 35.5 64.5 36.8991 64.5 38.625C64.5 40.3509 65.8991 41.75 67.625 41.75Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M75.1575 43.7791L64.5 55.5028H79.6662C80.9482 55.5028 82.1777 54.9935 83.0842 54.087C83.9907 53.1805 84.5 51.9511 84.5 50.6691V50.5028C84.5 49.9203 84.2813 49.6966 83.8875 49.2653L78.85 43.7716C78.6152 43.5155 78.3296 43.3111 78.0115 43.1715C77.6933 43.032 77.3495 42.9602 77.0021 42.9609C76.6547 42.9616 76.3112 43.0348 75.9936 43.1756C75.676 43.3165 75.3912 43.522 75.1575 43.7791V43.7791Z" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <rect v-if="active" x="1" y="1" width="138" height="88" stroke="#00ABEC" stroke-width="2"/>
      <rect v-else x="0.5" y="0.5" width="139" height="89" stroke="black"/>
    </svg>

  </div>
</template>

<script>

export default {
  name: 'WatermarkMode',
  props: {
    typeIcon: {
      type: String,
      default: 'vertical'
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.watermark-mode {
  width: 140px;
  height: 90px;
}

</style>
